import { useEffect, useState } from "react";
import { useTraccarSession } from "./useTraccarSession";
import { fetchResellerProfile, syncResellerDevices, AuthenticationError, type ResellerProfile } from "@/lib/reseller-api";

let syncedThisSession = false;

export function useResellerAccess() {
  const { user, isLoading } = useTraccarSession();
  const [profile, setProfile] = useState<ResellerProfile | null>(null);
  const [profileLoading, setProfileLoading] = useState(false);

  useEffect(() => {
    if (!user) return;
    let cancelled = false;
    setProfileLoading(true);
    fetchResellerProfile()
      .then(p => { if (!cancelled) setProfile(p); })
      .catch(e => { if (!cancelled && !(e instanceof AuthenticationError)) console.error(e); })
      .finally(() => { if (!cancelled) setProfileLoading(false); });
    return () => { cancelled = true; };
  }, [user?.id]);

  const isPrimaryReseller = !!user && !!profile && profile.traccar_user_id === user.id;
  const isFuncionario = !!user && !!profile && profile.traccar_user_id !== user.id;
  const isReseller = isPrimaryReseller || isFuncionario;

  useEffect(() => {
    if (isFuncionario && !syncedThisSession) {
      syncedThisSession = true;
      syncResellerDevices().catch(console.error);
    }
  }, [isFuncionario]);

  return {
    isReseller,
    isCheckingAccess: isLoading || (!!user && profileLoading),
  };
}
